var map = {
	"./common.json": "WxJK",
	"./development.json": "DFuO",
	"./new-staging.json": "hRdO",
	"./production.json": "tXSl",
	"./qa.json": "O7eq",
	"./staging.json": "lgH7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nwRb";